module.exports = __webpack_public_path__ + "img/衰.6f110650.png";